import React from 'react';
import { withTranslation } from 'react-i18next';

import PreviousSelectedAvatar from '@core/avatar/components/PreviousSelectedAvatar';
import ChooseAvatar from '@core/avatar/components/ChooseAvatar';

import { ISelectAvatarProviderPageView } from './interfaces';
import ContentWrapper from '@components/ContentWrapper';

const SelectAvatarProviderPageView = ({
  hasPreviousAvatar,
  t: translate,
}: ISelectAvatarProviderPageView) => {
  return (
    <ContentWrapper subtitle={translate('selectAvatar.description')}>
      {hasPreviousAvatar ? <PreviousSelectedAvatar /> : <ChooseAvatar />}
    </ContentWrapper>
  );
};

export default withTranslation()(SelectAvatarProviderPageView);
